import React from 'react';
import { IconProps } from './model/IconInterface';

const InfoIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </svg>
  );
};

export default InfoIcon;
